export class DiagnosisModel {
    ConceptID: number;
    PreferredTerm: string;
    OtherTerm?: string;
    EffectiveTime?: Date;
    ModuleID: number;
    DescriptionID: number;

    constructor(
        ConceptID: number,
        PreferredTerm: string,
        OtherTerm?: string,
        EffectiveTime?: Date,
        ModuleID?: number,
        DescriptionID?: number
    ) {
        this.ConceptID = ConceptID;
        this.PreferredTerm = PreferredTerm;
        this.OtherTerm = OtherTerm;
        this.EffectiveTime = EffectiveTime;
        this.ModuleID = ModuleID;
        this.DescriptionID = DescriptionID;
    }
}